
















import { defineComponent, computed, useRouter } from '~/utils/nuxt3-migration'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import CPagination from '~/components/shared/configurable/pagination/CPagination.vue'
import { useNamespacedStore } from '~/compositions/store'

export default defineComponent({
  components: { CPagination },
  props: {
    showTotals: {
      type: Boolean,
      required: false,
      default: false
    },
    rel: {
      type: String,
      default: null
    },
    showCustomSelect: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const {
      state: classifiedSearchState,
      getters: classifiedSearchGetters,
      dispatch: classifiedSearchDispatch
    } = useNamespacedStore(CLASSIFIED_SEARCH_NS)
    const router = useRouter()

    const seoUrl = computed(() => classifiedSearchState.page.seoUrl)

    const showSellers = computed(() => classifiedSearchGetters('showSellers'))

    const currentPage = computed(() =>
      classifiedSearchGetters('getResultsPaginationPage')
    )

    const numOfPages = computed(() => classifiedSearchGetters('getNumOfPages'))

    const totalRows = computed(() => classifiedSearchGetters('getTotalRows'))

    const loadingResults = computed(() => classifiedSearchState.loading.results)

    const pg = computed({
      get() {
        return currentPage.value
      },
      async set(page: boolean) {
        if (page === currentPage.value) {
          return
        }

        const url = new URL(window.location.href)
        url.searchParams.set('pg', page.toString())
        const newPageUrl = url.pathname + url.search

        await classifiedSearchDispatch('updateUrl', newPageUrl)
        classifiedSearchDispatch('updateRoutes')
        await classifiedSearchDispatch('changePage', {
          page
        })

        showSellers.value
          ? classifiedSearchDispatch('searchForSellers')
          : classifiedSearchDispatch('searchForResults', {
              loading: true,
              pageView: true
            })
      }
    })

    const paginationLinkGen = computed(() => {
      const baseUrl = seoUrl.value || router.currentRoute.fullPath

      return (pageNum: number) => {
        if (baseUrl.includes('pg=')) {
          return baseUrl.replace(/([?&]pg=)[^&]*/, `$1${pageNum}`)
        }

        const separator = baseUrl.includes('?') ? '&' : '?'
        return `${baseUrl}${separator}pg=${pageNum}`
      }
    })

    return {
      loadingResults,
      showSellers,
      currentPage,
      numOfPages,
      totalRows,
      paginationLinkGen,
      pg
    }
  }
})
